import { colors } from "./colors";

export const selectTheme = {
  // Multi-select styles for categories
  multiSelect: (hasError?: boolean) => ({
    menu: (baseStyles: any, state: any) => ({
      ...baseStyles,
      background: colors.background.formField,
      color: colors.text.white,
    }),
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      background: state.isFocused ? "#ccc" : colors.background.formField,
      color: state.isFocused ? colors.background.formField : colors.text.white,
    }),
    singleValue: (baseStyles: any, state: any) => ({
      ...baseStyles,
      color: colors.text.white,
    }),
    control: (baseStyles: any, state: any) => ({
      ...baseStyles,
      height: "50px",
      background: colors.background.formField,
      color: colors.text.white,
      border: hasError
        ? `1px solid ${colors.text.error}`
        : state.isFocused
          ? "1px solid transparent"
          : "1px solid transparent",
    }),
    multiValueRemove: (baseStyles: any) => ({
      ...baseStyles,
      color: "#000",
    }),
  }),

  // Single-select styles
  singleSelect: (hasError?: boolean) => ({
    menu: (baseStyles: any, state: any) => ({
      ...baseStyles,
      background: colors.background.formField,
      color: colors.text.white,
      border: `1px solid ${colors.background.lightWhite}`,
      boxShadow: "0 12px 28px rgba(0, 0, 0, 0.45)",
      overflow: "hidden",
      zIndex: 20,
    }),
    menuList: (baseStyles: any, state: any) => ({
      ...baseStyles,
      maxHeight: "240px",
      overflowY: "auto",
    }),
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      background: state.isSelected
        ? colors.background.darkGreen
        : state.isFocused
          ? "rgba(183, 248, 77, 0.12)"
          : colors.background.formField,
      color: state.isSelected ? colors.text.green : colors.text.white,
      cursor: state.isDisabled ? "not-allowed" : "pointer",
      opacity: state.isDisabled ? 0.45 : 1,
    }),
    singleValue: (baseStyles: any, state: any) => ({
      ...baseStyles,
      color: colors.text.white,
    }),
    control: (baseStyles: any, state: any) => ({
      ...baseStyles,
      height: "50px",
      background: colors.background.formField,
      color: colors.text.white,
      border: hasError
        ? `1px solid ${colors.text.error}`
        : state.isFocused
          ? `1px solid ${colors.text.green}`
          : "1px solid transparent",
      boxShadow: "none",
      cursor: "pointer",
      "&:hover": {
        borderColor: hasError ? colors.text.error : colors.background.lightWhite,
      },
    }),
    input: (baseStyles: any) => ({
      ...baseStyles,
      color: colors.text.white,
    }),
    dropdownIndicator: (baseStyles: any, state: any) => ({
      ...baseStyles,
      color: state.isFocused ? colors.text.green : colors.text.gray,
      "&:hover": { color: colors.text.green },
    }),
    indicatorSeparator: (baseStyles: any) => ({
      ...baseStyles,
      backgroundColor: colors.background.lightWhite,
    }),
    menuPortal: (baseStyles: any) => ({
      ...baseStyles,
      zIndex: 1100,
    }),
  }),

  // Multi-select with plan validation styles
  multiSelectWithValidation: (hasError?: boolean, plans?: any[]) => ({
    menu: (baseStyles: any, state: any) => ({
      ...baseStyles,
      background: colors.background.formField,
      color: colors.text.white,
    }),
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      background: state.isFocused ? "#ccc" : colors.background.formField,
      color: state.isFocused ? colors.background.formField : colors.text.white,
    }),
    singleValue: (baseStyles: any, state: any) => ({
      ...baseStyles,
      color: colors.text.white,
    }),
    control: (baseStyles: any, state: any) => ({
      ...baseStyles,
      height: "50px",
      background: colors.background.formField,
      color: colors.text.white,
      border: hasError
        ? `1px solid ${colors.text.error}`
        : state.isFocused
          ? "1px solid transparent"
          : "1px solid transparent",
    }),
    multiValue: (baseStyles: any, state: any) => ({
      ...baseStyles,
      backgroundColor:
        plans && !plans.find((plan: any) => plan.id === state.data.value)?.isEnabled
          ? colors.text.error
          : baseStyles.backgroundColor,
    }),
    multiValueLabel: (baseStyles: any, state: any) => ({
      ...baseStyles,
      color: "#000000",
    }),
    multiValueRemove: (baseStyles: any) => ({
      ...baseStyles,
      color: "#000",
    }),
  }),
};
